import { reactive as r, readonly as t } from "vue";
import { getCache as o, KnownDomain as i } from "@ado/client-side-caching";
const n = r({
  isSignedIn: !1,
  username: void 0,
  secureId: void 0,
  loginId: void 0,
  accountCreationLink: void 0,
  hasFreeAccount: !0
}), I = () => t(n), g = (e) => {
  a({
    isSignedIn: e.username !== void 0,
    secureId: e.secureId,
    loginId: e.loginId,
    username: e.username,
    accountCreationLink: void 0,
    hasFreeAccount: e.hasFreeAccount
  });
}, a = (e) => {
  n.isSignedIn = e.isSignedIn, n.secureId = e.secureId, n.loginId = e.loginId, n.username = e.username ?? "", n.accountCreationLink = e.accountCreationLink, n.hasFreeAccount = e.hasFreeAccount, s();
}, m = () => {
  n.isSignedIn = !1, n.secureId = void 0, s();
}, l = () => {
  n.isSignedIn = !1, n.username = "", n.secureId = "", n.loginId = void 0, n.accountCreationLink = "", n.hasFreeAccount = !0;
}, C = () => {
  const e = o().getItem(c());
  e !== void 0 && (n.accountCreationLink = e.accountCreationLink, n.isSignedIn = e.isSignedIn, n.loginId = e.loginId, n.username = e.username, n.hasFreeAccount = e.hasFreeAccount);
}, s = () => {
  const e = Object.assign({}, n);
  delete e.secureId, o().setItem(c(), e);
}, c = () => o().createKey(i.Foundation, "user");
export {
  g as authUser,
  I as getUser,
  l as resetUser,
  C as restoreUserFromCache,
  a as setUser,
  m as signOutUser
};
//# sourceMappingURL=index2.js.map
